<style>
</style>
<template>
<div id="card-charge">
  <v-select solo flat persistent-hint :items="items" v-model="inputValue" single-line :label="$t('Částka k dobití')" :hint="$t('Částka k dobití')">
    <template slot="selection" slot-scope="data">
      <v-col>{{ data.item | currency }}</v-col>
    </template>
    <template slot="item" slot-scope="data">
      <v-col>{{ data.item | currency }}</v-col>
    </template>
  </v-select>
</div>
</template>
<script>
export default {
  data() {
    return {
      // inputValue: 5000,
      items: [5000, 10000, 20000, 50000, 100000, 200000, 500000, 1000000]
    }
  },
  created() {
    // this.onChange(this.inputValue)
    this.inputValue = this.items[0]
  },
  computed: {
    inputValue: {
      get() {
        return this.items[0]
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
  // methods: {
  //   onChange(value) {
  //     this.$emit('input', value)
  //   }
  // }
}
</script>
